// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xAZ6J","text":"styles_text__KSe7U"};